import ProductPrice from './ProductPrice';
import LegalText from './LegalText';

export { LegalText };

export default ProductPrice;
